interface Props {
  size?: "sm" | "md" | "lg";
  href?: string;
}

const sizes = {
  sm: { forte: "text-[20px]", health: "text-[14px]" },
  md: { forte: "text-[25px]", health: "text-[18px]" },
  lg: { forte: "text-[33px]", health: "text-[23px]" },
};

export function Logo({ size = "lg", href }: Props) {
  const s = sizes[size];
  const inner = (
    <>
      <span
        className={`${s.forte} font-display text-fh-ink leading-none`}
        style={{ letterSpacing: "0.06em" }}
      >
        FORTE
      </span>
      <span
        className={`${s.health} font-sans font-medium text-fh-gold leading-none ml-1.5`}
        style={{ letterSpacing: "0.13em" }}
      >
        health
      </span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        aria-label="ForteHealth — go to homepage"
        className="flex items-baseline rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-fh-green focus-visible:ring-offset-2 focus-visible:ring-offset-fh-cream hover:opacity-90 transition"
      >
        {inner}
      </a>
    );
  }

  return <div className="flex items-baseline">{inner}</div>;
}
